export const AUTH_HEADER_KEY = "Authorization";
export const BEARER_TOKEN_TYPE = "Bearer";
export const REGION_HEADER_KEY = "x-region";
export const SC_USER_EMAIL_HEADER_KEY = "sc-user-email";
export const SC_REFERENCE_HEADER_KEY = "sc-reference-id";
export const VALID_REGIONS = ["us", "eu", "au"];
export const SC_SLATE_ID_HEADER_KEY = "SC-SLATE-ID";
